import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Tipos de Não Conformidade',
    path: '/nao-conformidade/nconaoconformidadetipo',
    name: 'nconaoconformidadetipo',
    goesToMenu: true,
    component: () => import('@/views/nao-conformidade/nco-nao-conformidade-tipo/Index.vue'),
    meta: {
      permissions: [EPermissoes.NaoConformidade_Configuracao],
      escopoObra: 'global'
    }
  }
];
